export const tipo_zonas = [
    { value: "info", label: "Informativa" }, 
    { value: "warning", label: "Advertencia"}, 
    { value: "danger", label: "Problema"},
    { value: "riesgo", label: "Alto riesgo" }
]

export const tipos_rastreo = [{ value: "zona", label: "Zona" }, { value: "ruta", label: "Ruta"}]

export const tipos_deteccion_automatizaciones = [ { value: "entrar", label: "Entrada" }, { value: "salida", label: "Salida"}]